export interface PaginationInterface {

  page: number;
  pages: number;
  pagesize: number;
  total: number;

}

export type { PaginationInterface as PaginationType };

export abstract class AbstractPaginator implements PaginationInterface {
  total = 0;

  page = 0;

  pagesize = 20;

  pages = 0;

  zeroBased = true

  get minPage() {
    return this.zeroBased ? 0 : 1
  }

  get maxPage() {
    return this.pages - (this.zeroBased ? 1 : 0);
  }

  get nextPage() {
    return Math.min(this.page + 1, this.maxPage);
  }

  get prevPage() {
    return Math.max(this.page - 1, this.minPage);
  }

  getVisiblePages(wide = 10): Record<string, any>[] {
    const pages: number[] = [];
    const p = this.page;
    const c = Math.max(this.minPage, p - wide / 2);
    const d = Math.min(p + wide / 2, this.maxPage);
    const a = this.minPage;
    const b = Math.min(a + wide / 2, c);
    const e = Math.max(this.maxPage - wide / 2, d);
    const f = this.maxPage;

    // console.log(a, b, c, d, e, f);
    // pages.push(1);
    // pages.push(5);

    for (let i = a; i < b; i++) {
      pages.push(i);
    }
    for (let i = c; i < d; i++) {
      pages.push(i);
    }
    for (let i = e; i <= f; i++) {
      pages.push(i);
    }
    return pages.map((i) => {
      return {
        value: i,
        text: this.zeroBased ? i + 1 : i,
        active: this.page == i,
      }
    })
  }
}

export class Paginator extends AbstractPaginator implements PaginationInterface {

  get showedStart() {
    return (this.page - (this.zeroBased ? 0 : 1)) * this.pagesize + 1
  }

  get showedStartZeroBased() {
    return Math.max(0, (this.page)) * this.pagesize + (this.zeroBased ? 0 : 1)
  }

  get showedEnd() {
    return Math.min(this.showedStart + this.pagesize - 1, this.total)
  }

  range(start, end) {
    return Array(end - start + 1).fill(1).map((_, idx) => start + idx);
  }

  totalRange() {
    return this.range(1, this.pages);
  }

  constructor(data?: Record<string, number> | PaginationInterface, zeroBased = true) {
    super();
    this.zeroBased = zeroBased
    if (data) this.setData(data);
  }

  setData(data: Record<string, number> | PaginationInterface) {
    Object.keys(this).forEach((key) => {
      if (key in data) { // or obj1.hasOwnProperty(key)
        this[key] = data[key];
      }
    });
  }


}


export class PrimevueBackofficePaginator {
  page = 0
  pages = 0
  total = 0
  pagesize = 100

  get showedStart() {
    return (this.page) * this.pagesize + 1
  }

  get showedEnd() {
    return Math.min(this.showedStart + this.pagesize - 1, this.total)
  }
}
